import ProfilePlaceholder from "../assets/img/profile-placeholder.png";
import { BUCKET_URL } from "./Url";

export default function getImageUrl(image: string | undefined | null): string {
  if (image) return `${BUCKET_URL}/file/${image}`;

  return ProfilePlaceholder;
}
